import React, {useContext, useState} from "react"
import "./app.css"
import styles from "./app.module.scss"
import {NavigationMenu} from "./navigation-menu/navigation-menu"
import {MenuToggle} from "./menu-toggle/menu-toggle"
import {Route, Switch} from "react-router-dom"
import {HeadingLarge} from "../components-shared/heading/heading"
import {DashboardPage} from "../components-features/dashboard/dashboard-page"
import {UnauthenticatedUser, UserContext} from "../services/authentication/user-context"
import {LoginPage} from "../components-features/login/login-page"
import {HomePage} from "../components-features/home/home-page"
import {SignUpPage} from "../components-features/sign-up/sign-up-page"
import {ClimateAdvicePage} from "../components-features/climate-advice/climate-advice-page"
import {PrivacyPolicyPage} from "../components-features/home/privacy-policy-page"
import {ClimateReportPage} from "../components-features/climate-report/climate-report-page"
import {Login} from "../components-features/login/login"
import {Page} from "../components-shared/page/page"
import {ConfirmPage} from "../components-features/sign-up/confirm-page"

function App() {
  const [isMenuVisible, setMenuVisible] = useState(false)

  return (
    <div className={styles.App}>

      <header className={styles.AppHeader}>
        <div className={styles.LogoContainer}>
          <img src="greenup-logo.jpg" alt="GreenUp logo" />

          <div className={styles.MenuButtonArea}>
            <MenuToggle isMenuVisible={isMenuVisible}
            onShowMenu={() => {
              setMenuVisible(true)
            }}
            onHideMenu={() => setMenuVisible(false)}/>
          </div>
        </div>
        <nav className={isMenuVisible ? styles.MenuAreaVisible : styles.MenuAreaInvisible}>
          <NavigationMenu onNavigated={() => setMenuVisible(false)}/>
        </nav>
      </header>
      <Content/>
    </div>

  )
}

const Content: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={HomePage}/>
      <Route path="/confirm" component={ConfirmPage}/>
      <Route path="/login" component={LoginPage}/>
      <Route path="/signup" component={SignUpPage}/>
      <Route path="/privacy" component={PrivacyPolicyPage}/>
      <AuthorizedRoute path="/dashboard" component={DashboardPage}/>
      <AuthorizedRoute path="/climate-report" component={ClimateReportPage}/>
      <AuthorizedRoute path="/climate-advice" component={ClimateAdvicePage}/>
      <Route path="/404">
        <HeadingLarge>404 Not Found</HeadingLarge>
      </Route>
    </Switch>
  )
}

interface AuthorizedRouteProps {
  path: string
  exact?: boolean
  component: any
}

const AuthorizedRoute: React.FC<AuthorizedRouteProps> = ({path, exact, component}) => {
  const user = useContext(UserContext)

  if (user === UnauthenticatedUser) {
    // show login form that only logs in and does not redirect to homepage
    return <Page title="Inloggen">
      <Login doNotRedirect />
    </Page>
  }

  return <Route path={path} exact={exact} component={component}/>
}

export default App
